import { ApiErrorCodes } from "@/Modules/App/Models/Api/ApiErrorCodes";
import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";

import { useScheduleStore } from "@/Modules/Schedule/Store";
import { useAppStore } from "@/Modules/App/Store";

import AppointmentTransformer from "@/Modules/Transformers/Appointment";

import { updateAppointment, type AppointmentApiQuery } from "@/Services/TherapyApi/Schedule";
import { isApiError } from "@/Services/Api/Typeguards/isApiError";

import { hasValue } from "@/Utils/Objects";

const UpdateAppointmentActionHandler = async (appointment: AppointmentApiQuery, appointmentUuid: string) => {
  const appStore = useAppStore();
  const scheduleStore = useScheduleStore();

  const appointmentResp = await updateAppointment(appointment, appointmentUuid).catch((e) => {
    const code = isApiError(e) ? e["error_code"] : null;

    if (code === ApiErrorCodes.SCHEDULE_ALREADY_EXISTS) {
      appStore.showSnackbar({
        type: NotificationType.ERROR,
        message: "schedule.therapist.edit_appointment.notification.duplicated",
      });
    } else {
      appStore.showSnackbar({
        type: NotificationType.ERROR,
        message: "schedule.therapist.edit_appointment.notification.error",
      });
    }

    return undefined;
  });

  if (!hasValue(appointmentResp)) return undefined;

  const appointmentDomain = AppointmentTransformer.toDomain(appointmentResp);

  const storedAppointmentIdx = scheduleStore.appointments?.findIndex(
    (appointment) => appointment.uuid === appointmentDomain.uuid
  );

  if (scheduleStore.appointments?.length && hasValue(storedAppointmentIdx) && storedAppointmentIdx !== -1) {
    scheduleStore.appointments[storedAppointmentIdx] = {
      ...scheduleStore.appointments[storedAppointmentIdx],
      ...appointmentDomain,
    };

    scheduleStore.appointments.sort((a, b) => a.startAt - b.startAt);
  }

  appStore.showSnackbar({
    type: NotificationType.SUCCESS,
    message: "schedule.therapist.edit_appointment.notification.success",
  });

  return appointmentDomain;
};

export default UpdateAppointmentActionHandler;
